import SidebarDal from '../dal/Sidebar';

class SideBar {

    static async getRegionData(URL, requestOption) {
        let response = await SidebarDal.getRegionData(URL, requestOption);
        return response;
    }
}
export default SideBar;